import { TransportMode } from '@ridango/components';

export type LegModeType = TransportMode | 'WAIT';

export const TRAVEL_PLANNER_WCAG_TRANSLATION_KEYS = {
    STEP: 'TRAVEL_PLANNER_WCAG_STEP',
    START_TIME: 'TRAVEL_PLANNER_WCAG_START_TIME',
    WALK_TO_DESTINATION: 'TRAVEL_PLANNER_WCAG_WALK_TO_DESTINATION',
    WALK_FROM_TO: 'TRAVEL_PLANNER_WCAG_WALK_FROM_TO',
    FINAL_ARRIVAL_TIME: 'TRAVEL_PLANNER_WCAG_FINAL_ARRIVAL_TIME',
    TRANSFER_TO_PLATFORM: 'TRAVEL_PLANNER_WCAG_TRANSFER_TO_PLATFORM',
    WAIT_FOR_NEXT_DEPARTURE: 'TRAVEL_PLANNER_WCAG_WAIT_FOR_NEXT_DEPARTURE',
    DEPARTURE_WITH_ORIGINAL: 'TRAVEL_PLANNER_WCAG_DEPARTURE_WITH_ORIGINAL',
    DEPARTURE: 'TRAVEL_PLANNER_WCAG_DEPARTURE',
    BOARD: 'TRAVEL_PLANNER_WCAG_BOARD',
    BOARD_ROUTE: 'TRAVEL_PLANNER_WCAG_BOARD_ROUTE',
    BOARD_OPERATED_BY: 'TRAVEL_PLANNER_WCAG_BOARD_OPERATED_BY',
    BOARD_TOWARDS: 'TRAVEL_PLANNER_WCAG_BOARD_TOWARDS',
    BOARD_AT: 'TRAVEL_PLANNER_WCAG_BOARD_AT',
    TRAVEL_STOP_SINGULAR: 'TRAVEL_PLANNER_WCAG_TRAVEL_STOP_SINGULAR',
    TRAVEL_STOP_PLURAL: 'TRAVEL_PLANNER_WCAG_TRAVEL_STOP_PLURAL',
    PRICE: 'TRAVEL_PLANNER_WCAG_PRICE',
    ARRIVE_AT: 'TRAVEL_PLANNER_WCAG_ARRIVE_AT',
    SERVICE_ALERT: 'TRAVEL_PLANNER_WCAG_SERVICE_ALERT',
    STOPS_LIST: 'TRAVEL_PLANNER_WCAG_STOPS_LIST',
    DOUBLE_TAP_SHOW_STOPS: 'TRAVEL_PLANNER_WCAG_DOUBLE_TAP_SHOW_STOPS',
    DOUBLE_TAP_HIDE_STOPS: 'TRAVEL_PLANNER_WCAG_DOUBLE_TAP_HIDE_STOPS',
    PLATFORM: 'TRAVEL_PLANNER_WCAG_PLATFORM',
    MODE_BUS: 'TRAVEL_PLANNER_WCAG_MODE_BUS',
    MODE_TRAM: 'TRAVEL_PLANNER_WCAG_MODE_TRAM',
    MODE_TRAIN: 'TRAVEL_PLANNER_WCAG_MODE_TRAIN',
    MODE_FERRY: 'TRAVEL_PLANNER_WCAG_MODE_FERRY',
    MODE_TROLLEYBUS: 'TRAVEL_PLANNER_WCAG_MODE_TROLLEYBUS',
    MODE_FLEXIBLE: 'TRAVEL_PLANNER_WCAG_MODE_FLEXIBLE',
    MODE_TRANSPORT: 'TRAVEL_PLANNER_WCAG_MODE_TRANSPORT'
} as const;
